import styled from '@emotion/styled';
import { ButtonLink } from '@blueprint/ui';
import { css } from '@emotion/react';

const SeoLinksWrapper = styled('div')(`
    width: 100%;
`);

const SeoLinksSection = styled.section(
    ({ theme }) => css`
        padding: ${theme.spacing['16px']} 0;
        margin-top: ${theme.spacing['32px']};
        background: ${theme.colors.white};
        box-shadow: 0px 2px 8px rgba(38, 38, 48, 0.2);
    `
);

const SeoLinksInnerWrapper = styled.div(
    ({ theme }) => css`
        padding: 0 ${theme.spacing['16px']};
    `
);

const StyledLinkBase = styled(ButtonLink)(
    ({ theme }) => css`
        margin: ${theme.spacing['8px']} 0;
        padding: 0;
        text-align: left;
        font-size: ${theme.fontSizes[1]};
        text-decoration: none;

        &:focus,
        &:hover {
            transform: none;
        }
    `
);

const CurrentlyAvailableLinkText = styled(StyledLinkBase)(
    () => css`
        display: inline-block;
        width: 100%;
    `
);

const TownsLinkText = styled(StyledLinkBase)(
    () => css`
        display: inline-block;
        width: 50%;
    `
);

export {
    SeoLinksWrapper,
    SeoLinksSection,
    SeoLinksInnerWrapper,
    CurrentlyAvailableLinkText,
    TownsLinkText
};
